import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faEnvelope,
  faPhone,
  faSave,
  faTrash,
} from "@fortawesome/fontawesome-free-solid";
import {
  faPen,
  faPenAlt,
  faPencil,
  faAnglesLeft,
  faAngleLeft,
  faAnglesRight,
  faAngleRight,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { SettingsPhoneTwoTone } from "@material-ui/icons";
import moment from "moment/moment";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/b2b/Modal";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";

import { useTable, usePagination } from "react-table";
// import { BasicTable } from "./Table";
// import { Paginated } from "./Paginated";
import data from "./data";
import { COLUMNS } from "./column";
import "./table.css";

import {
  setEventNextPage,
  setEventPrevPage,
  setFilterSearch,
  setFilterSearchPush,
} from "../../redux/app/event/event-slice";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Typography,
} from "@material-ui/core";
// import Table from "./Table";
// import { tableHeaders, tableData } from "./EventData";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";

const Event = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = React.useState(false);
  const { allRegionsOrSearch } = useSelector((state) => state.region);
  const { region, allEvents, eventPage } = useSelector((state) => state.event);

  // <BasicTable data={data} columns={COLUMNS} />;
  // <Paginated data={data} columns={COLUMNS} />;
  // console.log(region, "region");

  const initialState = {
    eventName: "",
    startDate: "",
    endDate: "",
    markup: "",
    regionType: "",
  };

  const [event, setEvent] = useState(initialState);

  const handleRegionInput = (e) => {
    if (e.target.value.length > 0) {
      dispatch(setFilterSearch({ filterSearch: [] }));
      for (let i in allRegionsOrSearch) {
        if (allRegionsOrSearch[i].name.toLowerCase().includes(e.target.value)) {
          dispatch(
            setFilterSearchPush({
              filterSearchRegion: allRegionsOrSearch[i],
            })
          );
        }
      }
    } else {
      dispatch(setFilterSearch({ filterSearch: [] }));
    }
  };

  useEffect(() => {
    dispatch({
      type: "GET_ALL_EVENTS",
      payload: {
        token: token,
        page: eventPage,
      },
    });

    dispatch({
      type: "GET_ALL_REGION_OR_SEARCH",
      payload: event.eventName.length > 0 ? event.eventName : undefined,
    });
  }, [eventPage]);

  const eventCreateHandler = (e) => {
    e.preventDefault();
    if (
      event.region === "" ||
      event.eventName === "" ||
      event.startDate === "" ||
      event.endDate === "" ||
      event.markup === ""
    ) {
      toast.warn("All fields are required!");
    } else {
      let body;
      if (
        region.split(" ")[0] === "global" ||
        region.split(" ")[0] === "flatregionglobal"
      ) {
        body = {
          regionType: region.split(" ")[1],
          eventName: event.eventName,
          startDate: event.startDate,
          endDate: event.endDate,
          markUp: event.markup,
        };
      } else {
        body = {
          region: region.split(" ")[0],
          regionType: region.split(" ")[1],
          eventName: event.eventName,
          startDate: event.startDate,
          endDate: event.endDate,
          markUp: event.markup,
        };
      }

      console.log(body, "body");

      dispatch({
        type: "CREATE_EVENT",
        payload: { token, body },
      });
      setEvent({
        eventName: "",
        startDate: "",
        endDate: "",
        markup: "",
      });

      setShowModal(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen mx-2 my-2">
          {/* <div className="text-xl text-primary">Event</div> */}
          <div className="flex justify-between">
            <div></div>
            <div>
              <button
                className="flex items-center px-2 py-2 space-x-2 text-sm text-white rounded-sm cursor-pointer bg-secondary hover:bg-gray-300 hover:text-black my-1 mr-4"
                type="button"
                onClick={() => setShowModal(true)}
              >
                <FontAwesomeIcon className="block w-5" icon={faPenAlt} />
                <div className="font-body">Create New Event</div>
              </button>

              {/* Start of Main modal */}

              {showModal ? (
                <>
                  <Modal
                    heading="Create Event"
                    cancelOnClick={() => {
                      setShowModal(false);
                    }}
                    addOnClick={eventCreateHandler}
                    addButtonLabel="Create New Event"
                    isEvent={true}
                    regionInput={handleRegionInput}
                    eventNameInput={(e) =>
                      setEvent({ ...event, eventName: e.target.value })
                    }
                    eventNameValue={event.eventName}
                    startDateInput={(e) => {
                      setEvent({ ...event, startDate: e.target.value });
                    }}
                    endDateInput={(e) => {
                      setEvent({ ...event, endDate: e.target.value });
                    }}
                    markupInput={(e) => {
                      setEvent({ ...event, markup: e.target.value });
                    }}
                  />
                  <div
                    className="fixed inset-0 z-40 bg-black opacity-25"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  ></div>
                </>
              ) : null}
              {/* End of Main modal */}
            </div>
          </div>
          <div className="text-xl font-semibold text-gray-700 border-b-2 mt-5 font-body">
            Created Events
          </div>
          <div className="flex space-x-3 pt-2 justify-end px-10 py-3">
            <div className=" font-body">Page: </div>
            <div
              onClick={() => {
                dispatch(setEventPrevPage());
              }}
              className="flex space-x-2 items-center cursor-pointer "
            >
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />
              <div className=" font-body">Prev</div>
            </div>

            <div
              onClick={() => {
                dispatch(setEventNextPage());
              }}
              className="flex space-x-2 items-center cursor-pointer"
            >
              <div className=" font-body">Next</div>
              <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </div>
          </div>

          <div className="h-screen scrollbar relative">
            <Paginated data={allEvents} columns={COLUMNS} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Event);

const Paginated = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination
  );

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  const { allEvents, eventsLoading } = useSelector((state) => state.event);
  const { pageIndex, pageSize } = state;

  const [delModal, setdelModal] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [editEventdata, setEditEventdata] = useState({
    eventId: "",
    eventName: "",
    startDate: "",
    endDate: "",
    markup: "",
    regionName: "",
  });

  const [delEventId, setDelEventId] = useState("");

  const editEventHandler = (e) => {
    e.preventDefault();
    const body = {
      eventName: editEventdata.eventName,
      startDate: editEventdata.startDate,
      endDate: editEventdata.endDate,
      markUp: editEventdata.markup,
    };

    //
    dispatch({
      type: "EDIT_EVENT",
      payload: { token, body, eventId: editEventdata.eventId },
    });
    seteditModal(false);
  };

  return (
    <>
      {delModal && (
        <>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative w-1/2 max-w-3xl mx-auto my-6">
              {/*content*/}
              <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-slate-200">
                  <h3 className="text-2xl font-medium text-[#fb4156]">
                    Delete Event
                  </h3>
                </div>
                <div className="text-xl font-medium py-3 mx-5">
                  Do you want to delete this event?
                </div>

                <div className="flex justify-end mx-3 space-x-3">
                  <button
                    className="mb-5  flex items-center justify-end px-2 py-2 space-x-3 text-black rounded-sm cursor-pointer border border-primary"
                    type="button"
                    onClick={() => {
                      setdelModal(false);
                    }}
                  >
                    <FontAwesomeIcon className="block w-5 mr-2" icon={faX} />
                    Cancel
                  </button>
                  <button
                    className="mb-5  flex items-center justify-end px-2 py-2 space-x-3 text-white rounded-sm cursor-pointer bg-secondary hover:bg-red-600 hover:shadow-md"
                    type="button"
                    onClick={() => {
                      dispatch({
                        type: "DELETE_EVENT",
                        payload: { token, eventId: delEventId },
                      });
                      setdelModal(false);
                    }}
                  >
                    <FontAwesomeIcon
                      className="block w-5 mr-2"
                      icon={faTrash}
                    />
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {editModal && (
        <>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
          <Modal
            heading="Edit Event"
            cancelOnClick={() => {
              seteditModal(false);
            }}
            addOnClick={editEventHandler}
            addButtonLabel="Edit Event"
            isEvent={true}
            isEditEvent={true}
            eventRegionName={editEventdata.regionName}
            eventNameInput={(e) =>
              setEditEventdata({ ...editEventdata, eventName: e.target.value })
            }
            eventNameValue={editEventdata.eventName}
            startDateInput={(e) =>
              setEditEventdata({ ...editEventdata, startDate: e.target.value })
            }
            startDateValue={moment(editEventdata.startDate).format(
              "DD-MM-YYYY"
            )}
            endDateInput={(e) =>
              setEditEventdata({ ...editEventdata, endDate: e.target.value })
            }
            endDateValue={moment(editEventdata.endDate).format("DD-MM-YYYY")}
            markupInput={(e) =>
              setEditEventdata({ ...editEventdata, markup: e.target.value })
            }
            markupValue={editEventdata.markup}
          />
        </>
      )}

      <table className="mainTable" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>

        {!eventsLoading ? (
          <tbody>
            {allEvents?.map((event) => {
              // console.log(event, "event");

              return (
                <tr key={event?._id}>
                  <td className="w-96 font-medium font-body">
                    {event?.eventName}
                  </td>
                  <td className="text-center">
                    {moment(event?.startDate).format("DD/MM/YYYY")}
                  </td>
                  <td className="text-center font-body">
                    {moment(event?.endDate).format("DD/MM/YYYY")}
                  </td>
                  <td className="text-center font-body">
                    {event?.region?.name}
                  </td>
                  <td className="text-center text-green-700 font-semibold font-body">
                    {event?.markUp + " %"}
                  </td>
                  <td>
                    <div className="flex text-center space-x-5 justify-center">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setEditEventdata({
                            eventId: event._id,
                            eventName: event.eventName,
                            startDate: new Date(event.startDate),
                            endDate: event.endDate,
                            markup: event.markUp,
                            regionName: event.region?.name,
                          });
                          seteditModal(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPencil}
                          className="text-green-600"
                        />
                      </div>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          console.log(event._id, "event._id");

                          setDelEventId(event._id);
                          setdelModal(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="text-primary"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        ) : (
          <>
            <tbody className="px-10">
              <tr>
                <td>
                  <Skeleton animation="wave" />
                </td>
                <td>
                  <Skeleton animation="wave" />
                </td>
                <td>
                  <Skeleton animation="wave" />
                </td>
                <td>
                  <Skeleton animation="wave" />
                </td>
                <td>
                  <Skeleton animation="wave" />
                </td>
                <td>
                  <Skeleton animation="wave" />
                </td>
              </tr>
            </tbody>
          </>
        )}
      </table>
    </>
  );
};
